<template>
  <!-- bootstrap-vue b-dropdown-item: li[role=presentation] > a.dropdown-item[role=menuitem].
       `to` → router-link (aynı active / exact-active sınıfları), `href` → düz bağlantı, ikisi de
       yoksa href="#" (varsayılan gezinme engellenir). Tıklamada click yayar ve menüyü kapatır. -->
  <li role="presentation">
    <router-link v-if="to" :to="to" custom v-slot="{ href: routeHref, navigate, isActive, isExactActive }"><a :href="routeHref" target="_self" role="menuitem" class="dropdown-item" :class="[linkClasses, isActive && routeActiveClass, isExactActive && routeExactActiveClass]" @click="onRouterClick($event, navigate)"><slot /></a></router-link>
    <a v-else :href="href || '#'" target="_self" role="menuitem" class="dropdown-item" :class="linkClasses" @click="onClick"><slot /></a>
  </li>
</template>

<script>
  export default {
    name: 'BaseDropdownItem',
    emits: ['click'],
    inject: {
      baseDropdown: { default: null }
    },
    props: {
      to: { type: [String, Object], default: null },
      href: { type: String, default: null },
      // vue-router 4'te router-link `exact` yok; etkin sınıf isExactActive'e göre (bootstrap-vue API'si için kalır).
      exact: { type: Boolean, default: false },
      active: { type: Boolean, default: false },
      // router-link varsayılanları; '' verilirse sınıf eklenmez (vue-router 3 davranışı)
      activeClass: { type: String, default: null },
      exactActiveClass: { type: String, default: null },
      variant: { type: String, default: null },
      linkClass: { type: [String, Array, Object], default: null }
    },
    computed: {
      linkClasses() {
        return [
          this.linkClass,
          { active: this.active, [`text-${this.variant}`]: !!this.variant && !this.active }
        ];
      },
      routeActiveClass() {
        return this.activeClass === null ? 'router-link-active' : this.activeClass;
      },
      routeExactActiveClass() {
        return this.exactActiveClass === null ? 'router-link-exact-active' : this.exactActiveClass;
      }
    },
    methods: {
      closeDropdown() {
        const dropdown = this.baseDropdown;
        if (dropdown) window.requestAnimationFrame(() => dropdown.hide(true));
      },
      onClick(event) {
        if (!this.href || this.href === '#') event.preventDefault();
        this.$emit('click', event);
        this.closeDropdown();
      },
      onRouterClick(event, navigate) {
        this.$emit('click', event);
        navigate(event);
        this.closeDropdown();
      }
    }
  };
</script>
